import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'
import Indicators from './Indicators'
import Plans from './Plans'
import Range from './Range'
import Bottom from './Bottom'

export class Slider extends Component {
  state = {
    selectedPlan: 0,
    monthlyTextMessages: 5000,
  }

  plans = [
    {
      name: 'Basic',
      rate: 0.01,
    },
    {
      name: 'Standard',
      rate: 0.02,
    },
    {
      name: 'Premium',
      rate: 0.03,
    },
    {
      name: 'Premium Pro',
      rate: 0.04,
    },
  ]

  baseClass = extendParentClass.bind(this)('slider')

  setKeyAndValue = (key) => (value) =>
    this.setState((prevState) => ({ ...prevState, [key]: value }))

  setSelectedPlan = this.setKeyAndValue('selectedPlan')

  setMonthlyTextMessages = this.setKeyAndValue('monthlyTextMessages')

  extend = extendBaseClass.bind(this)

  getPrice = () => {
    const { selectedPlan, monthlyTextMessages } = this.state
    const { rate } = this.plans[selectedPlan]
    return rate * monthlyTextMessages
  }

  render() {
    const { monthlyTextMessages } = this.state
    const top = this.extend('top')
    return (
      <div className={this.baseClass}>
        <div className={top}>
          <h3 className={extend(top, 'title')}>Estimate Your Price</h3>
          <Plans
            plans={this.plans}
            setSelectedPlan={this.setSelectedPlan}
            parentClass={top}
          />
          <Indicators
            monthlyTextMessages={monthlyTextMessages}
            price={this.getPrice()}
            parentClass={top}
          />
          <Range
            parentClass={top}
            monthlyTextMessages={monthlyTextMessages}
            setMonthlyTextMessages={this.setMonthlyTextMessages}
          />
        </div>
        <Bottom parentClass={this.baseClass} />
      </div>
    )
  }
}

export default Slider
